import { render, staticRenderFns } from "./ByCustomerList.vue?vue&type=template&id=1dddc47b&scoped=true&"
import script from "./ByCustomerList.vue?vue&type=script&lang=js&"
export * from "./ByCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dddc47b",
  null
  
)

export default component.exports